var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSwitchOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 36,
    viewBox: "0 0 52 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_449_18)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.5631 4.07134C32.1984 3.99392 30.8353 4.00012 29.4706 4.00012C29.4612 4.00012 22.5553 4.00012 22.5553 4.00012C21.1639 4.00012 19.8008 3.99392 18.4369 4.07134C17.1969 4.14102 15.989 4.28967 14.7867 4.6218C12.2557 5.32012 10.0455 6.7787 8.44784 8.84657C6.85961 10.9013 6 13.4166 6 15.9993C6 18.5852 6.85961 21.099 8.44784 23.1537C10.0455 25.2208 12.2557 26.6801 14.7867 27.3784C15.989 27.7106 17.1969 27.8584 18.4369 27.9289C19.8008 28.0063 21.1639 27.9993 22.5286 27.9993C22.538 27.9993 29.4455 28.0001 29.4455 28.0001C30.8353 27.9993 32.1984 28.0063 33.5631 27.9289C34.8024 27.8584 36.0102 27.7106 37.2125 27.3784C39.7435 26.6801 41.9537 25.2208 43.5514 23.1537C45.1396 21.099 46 18.5852 46 16.0001C46 13.4166 45.1396 10.9013 43.5514 8.84657C41.9537 6.7787 39.7435 5.32012 37.2125 4.6218C36.0102 4.28967 34.8024 4.14102 33.5631 4.07134Z",
    fill: "#EED03A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34 26C28.4772 26 24 21.5228 24 16C24 10.4772 28.4772 6 34 6C39.5228 6 44 10.4772 44 16C44 21.5228 39.5228 26 34 26Z",
    fill: "#272B37"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_449_18",
    x: 0,
    y: 0,
    width: 52,
    height: 36,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.375
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_449_18"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_449_18",
    result: "effect2_dropShadow_449_18"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_449_18",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwitchOn);
export default __webpack_public_path__ + "static/media/switch-on.969f7611b69d788d05de7a594ce50c15.svg";
export { ForwardRef as ReactComponent };